/**!
 * QCE ATAR Calculator
 * By Daniel15 - 2011-2019
 * Feel free to use any of this, but please link back to my site (dan.cx)
 */

import '../../css/main.css';

import React from 'react';
import ReactDOM from 'react-dom';

import {initAnalytics} from '../analyticsLogger';
import CalculatorQCE from '../components/CalculatorQCE';
import CalculatorContainer from '../containers/CalculatorContainer';
import Data from '../../data/qce.json';
import {State} from '../constants';

ReactDOM.render(
  <CalculatorContainer
    appConfig={{
      ...Data,
      alertMessage: (
        <>
          Latest update: 29th May 2023: The site has been updated to reflect
          2022 scaling data. Calculations should still be taken as an estimate
          only, as some data (such as a mapping from TEA to ATAR) are
          unavailable. Please report any errors by emailing{' '}
          <strong>
            <a href="mailto:%63%61l&#99;%40at%61r%6e%6ftes%2e&#99;om">
              calc@atarnotes.com
            </a>
          </strong>
          . QTAC does not endorse or have any involvement in any material
          appearing on this website.
        </>
      ),
      bugReportMessage: null,
      resourcesURL: 'https://atarnotes.com/free-qce-resources/',
      showSuggestedCourses: true,
      state: State.QCE,
    }}
    calculator={CalculatorQCE}
  />,
  document.getElementById('calculator'),
);

initAnalytics(State.QCE);
